module.exports = __webpack_public_path__ + "img/115a84d12a8f5be6ee01c4e0306e3c6e.a04b7963.png";